// Página local /medico-para-emagrecer-em-bauru/ no template das páginas de
// tratamento. Texto de src/content/locais/medico-para-emagrecer-em-bauru.md,
// distribuído nos blocos sem reescrita.
import { EtapasLocais as CardsIlustrado, CtaLocal as CtaPratico, FaqLocal as Faq, HeroLocal as Hero, MedicoLocal as Medico, PilaresLocais as Pilares } from "@/components/itv/pages/locais";
import { MarkdownInline } from "@/components/blog/Markdown";
import { AutoriaComAviso, BotaoWhatsApp, MapaConsultorio, RQES_LOCAIS, SecaoTexto, Texto } from "@/components/itv/pages/locais";

export const faqEmagrecerBauru = [
  {
    pergunta: "Qual o médico mais indicado para emagrecer em Bauru?",
    resposta:
      "Para tratar sobrepeso e obesidade, procure um médico que cuide da obesidade como doença crônica, como o nutrólogo ou o endocrinologista. Mais do que o título, contam a avaliação completa e o acompanhamento ao longo do tempo. Em Bauru, o Dr. Thiago Viana atende como médico nutrólogo no Jardim Europa, com bioimpedância inclusa na consulta.",
  },
  {
    pergunta: "Que especialidade trata obesidade?",
    resposta:
      "A obesidade é tratada por médicos, com destaque para nutrólogos e endocrinologistas. A ABRAN inclui o diagnóstico e o tratamento da obesidade na atuação do nutrólogo, e a SBEM, sociedade dos endocrinologistas, assina com a ABESO o posicionamento brasileiro sobre medicamentos para obesidade. ABESO e SBEM descrevem a obesidade como doença crônica e recorrente.",
  },
  {
    pergunta: "O que uma clínica de emagrecimento faz e o que muda num tratamento médico?",
    resposta:
      "Clínica de emagrecimento é um nome amplo, que pode reunir procedimentos estéticos, protocolos e pacotes de sessões. No tratamento médico, a consulta investiga a causa do ganho de peso, avalia doenças associadas, pede exames quando fazem sentido e, se houver indicação, prescreve medicamento, com retornos que ajustam o plano conforme a resposta.",
  },
  {
    pergunta: "O nutrólogo receita remédio para emagrecer?",
    resposta:
      "Sim, quando há indicação. O nutrólogo é médico e pode prescrever medicamentos para obesidade aprovados pela Anvisa, depois de avaliar grau de obesidade, doenças associadas, exames e histórico. O medicamento entra junto com mudanças de alimentação, exercício e sono, nunca no lugar delas, e o uso é acompanhado em consulta. Não use por conta própria.",
  },
  {
    pergunta: "Preciso levar exames na primeira consulta?",
    resposta:
      "Não é obrigatório. Se você tem exames recentes, leve os que tiver, junto com a lista de remédios e suplementos em uso. Na consulta, o Dr. Thiago avalia o que já existe e pede apenas o que faz sentido para o seu caso. A equipe orienta você no agendamento pelo WhatsApp.",
  },
];

const pilares = [
  {
    icone: "/icones/search.svg",
    titulo: "A obesidade é uma doença crônica",
    texto: (
      <MarkdownInline texto="Nasce da mistura entre ambiente, emoções, rotina e uma tendência biológica que varia de pessoa para pessoa ([OMS](https://www.who.int/news-room/fact-sheets/detail/obesity-and-overweight)). Ela também tende a voltar, e por isso tratar inclui manter o peso perdido." />
    ),
  },
  {
    icone: "/icones/flame.svg",
    titulo: "Não se trata apenas com dieta",
    texto: (
      <MarkdownInline texto="Quem perdeu muito peso só fechando a boca é exceção. Na maioria das pessoas, cortar a comida de uma vez traz a fome de volta e o peso volta junto, no conhecido [efeito sanfona](/blog/efeito-sanfona/)." />
    ),
  },
  {
    icone: "/icones/clipboard.svg",
    titulo: "Quando o peso não cede",
    texto: (
      <MarkdownInline texto="Vale investigar as [causas médicas de não conseguir emagrecer](/blog/nao-consigo-emagrecer/). O nutrólogo e o endocrinologista são as especialidades que fazem esse diagnóstico e esse tratamento." />
    ),
  },
];

const etapas = [
  {
    img: "/img/emagrecimento/conduta-1.webp",
    titulo: "A primeira consulta olha para a história do seu peso",
    texto: (
      <MarkdownInline texto="Segue a lógica da [Avaliação 360°](/tratamentos/avaliacao-360/): quando o peso começou a subir, quais dietas e remédios você já tentou e o que aconteceu depois. A bioimpedância feita no consultório estima quanto do seu peso é gordura e quanto é massa magra." />
    ),
  },
  {
    img: "/img/emagrecimento/conduta-2.webp",
    titulo: "Exames conforme o caso",
    texto: "Pedidos conforme a avaliação, para olhar pontos como resistência à insulina, tireoide e deficiências nutricionais. A coleta é feita no laboratório de sua preferência.",
  },
  {
    img: "/img/emagrecimento/conduta-3.webp",
    titulo: "Reavaliações",
    texto: "Nos retornos, ajustamos alimentação, exercício e, quando for o caso, medicação. A composição corporal pode ser medida de novo, para conferir se a perda vem da gordura e se a massa muscular está preservada.",
  },
];

const paragrafosMedico = [
  "Em Bauru, o Dr. Thiago Viana, médico nutrólogo (RQE 121770), trata sobrepeso e obesidade investigando as causas, com exames conforme o caso, plano de alimentação e exercício e, quando há indicação, medicação.",
  "É membro do European Board of Obesity Medicine (EBOM) e do Pan American Board of Obesity Medicine (PABOM). Formação pela UNIFESP-EPM, em 2010.",
];

export function EmagrecerBauru() {
  return (
    <main className="pag-local">
      <Hero
        trilha={[
          { nome: "Home", href: "/" },
          { nome: "Consultório em Bauru", href: "/bauru/" },
          { nome: "Médico para emagrecer em Bauru" },
        ]}
        sobretitulo="ATENDIMENTO EM BAURU"
        linha1="Médico para emagrecer"
        linha2="em Bauru."
        chamada="Em Bauru, o Dr. Thiago Viana, médico nutrólogo (RQE 121770), trata sobrepeso e obesidade investigando as causas, com exames conforme o caso, plano de alimentação e exercício e, quando há indicação, medicação. A bioimpedância está inclusa na consulta presencial, no Jardim Europa."
        imagem="/img/emagrecimento/hero.webp"
        botao="Agendar avaliação"
      />

      <Pilares
        sobretitulo="EM Bauru"
        titulo="Qual médico procurar para emagrecer"
        chamada="Para tratar sobrepeso e obesidade, procure um médico que cuide da obesidade como doença. O nutrólogo e o endocrinologista são as especialidades que fazem esse diagnóstico e esse tratamento. Na escolha, conta muito que o médico avalie o seu caso inteiro e acompanhe você ao longo do tempo."
        itens={pilares}
      />


      <SecaoTexto titulo="Tratamento médico ou clínica de emagrecimento: o que muda" areia>
        <Texto
          texto={`Quem procura emagrecimento em Bauru encontra dois tipos de serviço com nomes parecidos. Clínica de emagrecimento é um nome amplo, que pode reunir procedimentos estéticos, protocolos prontos e pacotes de sessões, com ou sem um médico conduzindo o caso.

No tratamento médico, tudo parte do diagnóstico. O médico levanta a história do peso, examina, pede exames quando fazem sentido, avalia doenças associadas e, se houver indicação, prescreve medicamento. O plano é ajustado a cada retorno, conforme a resposta do seu corpo, sem número fixo de sessões.

Os dois caminhos podem se somar. Procedimentos para flacidez e gordura localizada ajudam muita gente depois de emagrecer. No consultório, eles entram depois da avaliação médica, como parte da [estética integrada](/tratamentos/estetica-regenerativa/).`}
        />
      </SecaoTexto>

      <CardsIlustrado
        sobretitulo="NO CONSULTÓRIO"
        titulo="Como funciona o tratamento de obesidade no consultório de Bauru"
        chamada="Quem conduz a primeira consulta e os retornos é o próprio Dr. Thiago."
        cards={etapas}
      />

      <SecaoTexto areia>
        <MapaConsultorio avaliacoes />
      </SecaoTexto>

      <SecaoTexto titulo="Emagrecer sem perder massa muscular">
        <Texto texto="Parte do peso perdido pode sair da massa muscular, e o risco é maior depois dos 60 anos e em quem já tem pouca força. Por isso o treino de força e a proteína adequada entram junto com o tratamento, inclusive quando há medicamento. No acompanhamento, a bioimpedância ajuda a vigiar esse ponto e o exercício entra como parte do tratamento. O passo a passo está no artigo sobre [como emagrecer sem perder massa muscular](/blog/emagrecer-sem-perder-massa-muscular/)." />
      </SecaoTexto>

      <SecaoTexto titulo="Medicamentos para obesidade: quando entram no tratamento" areia>
        <Texto
          texto={`Medicamentos podem fazer parte do tratamento, mas não são a base dele e não substituem os hábitos de vida. Eles funcionam junto com a mudança de rotina e, quando usados por mais tempo, pedem reavaliações periódicas de eficácia e segurança ([Diretriz ABESO 2026](https://abeso.org.br/wp-content/uploads/2026/03/Diretrizes-ABESO_completo_20260320.pdf)).

A indicação é decidida na consulta, a partir do grau de obesidade, das doenças associadas, dos exames e do seu histórico. Quando o medicamento entra, inclusive os injetáveis conhecidos como canetas, o uso é acompanhado de perto, com atenção à massa muscular e ao momento da retirada.

Muita gente usa remédio para emagrecer sem indicação, só por estética, e confunde tratamentos aprovados pela Anvisa com fórmulas manipuladas, ervas vendidas na internet e injeções sem controle sanitário. Por segurança, não comece, troque nem suspenda um medicamento por conta própria.`}
        />
      </SecaoTexto>

      <SecaoTexto titulo="Para quem mora na região de Bauru">
        <Texto texto="A teleconsulta permite fazer avaliação e acompanhamento por vídeo, com análise de histórico, sintomas, hábitos e exames. Quando o caso pede exame físico ou uma avaliação específica, a consulta presencial em Bauru é indicada. Quem não pode vir a Bauru faz o acompanhamento pela [teleconsulta](/consulta-online/), que atende todo o Brasil." />
      </SecaoTexto>

      <SecaoTexto titulo="Avaliação para emagrecer em Bauru" areia>
        <Texto
          texto={`O tratamento combina as frentes que o diagnóstico indicar. Entram estratégia alimentar que você consiga manter, exercício com foco em massa muscular e suplementação quando há evidência e indicação. Medicação entra quando indicada, e flacidez e queda de cabelo são cuidadas durante o processo. A explicação completa de cada etapa está na página do [tratamento de emagrecimento](/tratamentos/emagrecimento/).

Se emagrecer virou uma luta e você quer entender o que trava o seu caso, o primeiro passo é uma avaliação individualizada. Dentro do Método SP, ela olha composição corporal, alimentação, sono e exames juntos. O atendimento é presencial em Bauru e por teleconsulta em todo o Brasil.`}
        />
        <BotaoWhatsApp rotulo="Agendar avaliação" />
      </SecaoTexto>

      <Medico paragrafos={paragrafosMedico} rqes={RQES_LOCAIS} />
      <Faq titulo="Perguntas frequentes" itens={faqEmagrecerBauru} />
      <AutoriaComAviso />
      <CtaPratico linha1="Comece seu tratamento de" linha2="emagrecimento em Bauru. Escolha o formato." />
    </main>
  );
}
